<template>
    <div :class="{'mobile-menu-upgrade': true, 'selected': selected}" v-if="!hasPremium">
        <a :href="url"><Crown :baseData="baseData" size="24" /> {{name}}</a>
    </div>
</template>

<script>
import Crown from '@root/lk/create/CreateChallenge/Crown.vue';

export default {
    props: ["name", "icon", "url", "top"],
    components: {
        Crown,
    },
    computed: {
        hasPremium() {
            const user = this.baseData?.viewingUser;
            if (!user) return false;
            if (!user.permissions) return false;
            if (!user.permissions.activePlans) return false;
            return user.permissions.activePlans.length > 0;
        },
    },
    mounted() {
        this.refresh();
        window.addEventListener('mobile-menu-recalc-item', this.refresh);
    },
    unmounted() {
        window.removeEventListener('mobile-menu-recalc-item', this.refresh);
    },
    data() {
        return {
            selected: false,
        };
    },
    methods: {
        isCurrent() {            
            const url = document.location.pathname;
            if (url === this.url) {
                return true;
            }
            const index = url.indexOf(this.url);
            if (index > 0) {
                const diff = url.replace(this.url, "");
                console.warn(`url=${url}, url2=${this.url}, diff=${diff}`);
                if (diff[0] == '/') {
                    if (diff.length == 3) {
                        console.log("YES3");
                        return true;
                    }
                    if (diff.length == 5 && diff[3] == "-") {
                        console.log("YES5");
                        return true;
                    }
                }
            }
            return false;
        },
        refresh() {
            this.selected = this.isCurrent();
        },
    }
}
</script>

<style lang="scss" scoped>
    .mobile-menu-upgrade {
        display: flex;
        align-items: center;
        margin: 0 auto;
        padding-bottom: 16px;
        padding-top: 32px;
                
        a { 
            //margin-left: 16px;
            //margin-right: 16px;
            color: #FFC107;  
            font-size: 18px;
            font-weight: 600;         
            text-decoration: none;
            width: 100%;
            img {
                position: relative;
                bottom: 1px;
            }
        }
        /*&.selected {
            a {
                background: darkcyan;
                color: white;
            }
        }*/
    }
</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
